import BaseModal from '../BaseModal';

export default BaseModal;
